import { NzMessageService } from 'ng-zorro-antd/message';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';
import { LayoutService } from 'src/app/layout/layout.service';
import { EventType, RecordModel } from 'src/app/layout/record-model';
import { ModuleStructure } from '../module-structure';

export class SalesOpportunity {
  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService
  ) {
    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      try {
        this.fieldChanged(args);
      } catch (e) {
        console.log(
          'An error occured while trying to execute sales opportunity logic.',
          args,
          e
        );
      }
    });

    layoutService.objectLoadChanged.subscribe(
      (args: {
        recordModel: RecordModel;
        moduleStructure: ModuleStructure;
      }) => {
        try {
          this.ObjectLoad(args);
        } catch (e) {
          console.log(
            'error during loading the object in sales opportunity, the error is:',
            e
          );
        }
      }
    );
  }

  ObjectLoad(args: {
    recordModel: RecordModel;
    moduleStructure: ModuleStructure;
  }) {
    if (args.moduleStructure.module.ObjectTypeValue !== '97') {
      return;
    }

    console.log('is opp');
    if (args.recordModel.EventType === EventType.Create) {
      console.log('Add');
      const sectionStages = args.recordModel.Categories.find(
        (x) => x.Id === 'SalesOpportunitiesLines'
      );

      const firstStage = sectionStages.Lines[0];

      const stageKey = firstStage.Properties.find(
        (prop) => prop.Name === 'StageKey'
      );

      const percentageRate = firstStage.Properties.find(
        (prop) => prop.Name === 'PercentageRate'
      );

      const stageKeyName = firstStage.Properties.find(
        (prop) => prop.Name === 'StageKeyName'
      );

      this.layoutService.executeQuery(2806, {}).subscribe((d: any[]) => {
        console.log(d);
        stageKey.ValueAsObject = d[0].Value;
      });

      this.layoutService.executeQuery(2807, {}).subscribe((d: any[]) => {
        console.log(d);
        percentageRate.ValueAsObject = d[0].Value;
      });

      this.layoutService.executeQuery(2808, {}).subscribe((d: any[]) => {
        console.log(d);
        stageKeyName.ValueAsObject = d[0].Value;
      });
    }
  }

  fieldChanged(args: FieldValueChangedArgs) {
    if (
      args.sectionTagName === 'SalesOpportunities' ||
      args.sectionTagName === 'Documents'
    ) {
      return;
    }

    if (args.recordProperty === undefined) return;

    // if (
    //   args.recordProperty.Name !== 'PercentageRate' &&
    //   args.recordProperty.Name !== 'DocTotal' &&
    //   args.recordProperty.Name !== 'DocumentType'
    // ) {
    //   return;
    // }
    const section = args.recordModel.Categories.find(
      (x) => x.Id === args.sectionTagName
    );

    const sectionHeader = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunities'
    );

    let field = section.Lines.find((l) => l.Id === args.line).Properties.find(
      (prop) => prop.Name === args.recordProperty.Name
    );

    if (field != null || field !== undefined) {
      field = args.recordProperty;
    }

    if (args.recordProperty.Name === 'PercentageRate') {
      const percent = +field.ValueAsObject;
      const maxTotal =
        (section.Lines.find((l) => l.Id === args.line).Properties.find(
          (prop) => prop.Name === 'MaxLocalTotal'
        ).ValueAsObject *
          percent) /
        100;
      section.Lines.find((l) => l.Id === args.line).Properties.find(
        (prop) => prop.Name === 'WeightedAmountLocal'
      ).ValueAsObject = maxTotal;
      console.log('percent maxTotal', percent, maxTotal);

      sectionHeader.Lines[0].Properties.find(
        (prop) => prop.Name === 'WeightedSumLC'
      ).ValueAsObject = maxTotal;
    }

    if (args.recordProperty.Name === 'DocTotal') {
      const docTotal = +field.ValueAsObject;
      if (
        docTotal === undefined ||
        !this.isNumber(docTotal) ||
        docTotal === 0
      ) {
        return;
      }
      let confirmChoice = confirm(
        this.layoutService.translate('Update Amount and Gross Profit?')
      );

      if (confirmChoice) {
        if (sectionHeader !== undefined) {
          sectionHeader.Lines[0].Properties.find(
            (prop) => prop.Name === 'MaxLocalTotal'
          ).ValueAsObject = docTotal;
          const percent = section.Lines.find(
            (l) => l.Id === args.line
          ).Properties.find(
            (prop) => prop.Name === 'PercentageRate'
          ).ValueAsObject;
          section.Lines.find((l) => l.Id === args.line).Properties.find(
            (prop) => prop.Name === 'MaxLocalTotal'
          ).ValueAsObject = docTotal;
          section.Lines.find((l) => l.Id === args.line).Properties.find(
            (prop) => prop.Name === 'WeightedAmountLocal'
          ).ValueAsObject = (docTotal * percent) / 100;
          sectionHeader.Lines.find((l) => l.Id === args.line).Properties.find(
            (prop) => prop.Name === 'WeightedSumLC'
          ).ValueAsObject = (docTotal * percent) / 100;
          console.log('docTotal maxTotal', docTotal, percent);
        }
      }
    }
    // need to impliment JS file line 160
    if (args.recordProperty.Name === 'DocumentType') {
      const docTotal = +field.ValueAsObject;
      if (
        docTotal === undefined ||
        !this.isNumber(docTotal) ||
        docTotal === 0
      ) {
        return;
      }
      const linkedObject = section.Lines.find(
        (l) => l.Id === args.line
      ).Properties.find((prop) => prop.Name === 'RealDocumentNumber');

      console.log('DocumentType maxTotal', field.ValueAsObject, linkedObject);
    }
    if (args.recordProperty.Name === 'GrossProfit') {
      this.GrossProfitPercent(args);
    }
    if (args.recordProperty.Name === 'TotalAmountLocal') {
      this.GrossProfitTotal(args);
    }
    if (args.recordProperty.Name === 'MaxLocalTotal') {
      sectionHeader.Lines[0].Properties.find(
        (prop) => prop.Name === 'MaxLocalTotal'
      ).ValueAsObject = args.recordProperty.ValueAsObject;

      this.PotentialAmount(args);
    }

    // LayoutService.setValue(
    //     taxValueElement,
    //     newValue,
    //     this.layoutService,
    //     args.recordModel,
    //     element.Id,
    //     'Document_Lines',
    //     args.moduleStructure
    //   );
  }

  GrossProfitPercent(args: FieldValueChangedArgs) {
    const section = args.recordModel.Categories.find(
      (x) => x.Id === args.sectionTagName
    );

    const sectionHeader = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunities'
    );

    const maxLocalTotalElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'MaxLocalTotal'
    );
    const grossProfitElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'GrossProfit'
    );
    const totalAmountLocalElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalAmountLocal'
    );

    const maxLocalTotal = maxLocalTotalElem.ValueAsObject;
    const grossProfit = grossProfitElem.ValueAsObject;
    const totalAmountLocal = (maxLocalTotal * grossProfit) / 100;

    LayoutService.setValue(
      totalAmountLocalElem,
      totalAmountLocal,
      this.layoutService,
      args.recordModel,
      0,
      args.sectionTagName,
      args.moduleStructure
    );

    console.log(
      'GrossProfitPercent totalAmountLocalElem',
      totalAmountLocal,
      totalAmountLocalElem.ValueAsObject
    );
  }

  GrossProfitTotal(args: FieldValueChangedArgs) {
    const section = args.recordModel.Categories.find(
      (x) => x.Id === args.sectionTagName
    );

    const sectionHeader = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunities'
    );

    const maxLocalTotalElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'MaxLocalTotal'
    );
    const grossProfitElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'GrossProfit'
    );
    const totalAmountLocalElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalAmountLocal'
    );

    const maxLocalTotal = maxLocalTotalElem.ValueAsObject;
    const totalAmountLocal = totalAmountLocalElem.ValueAsObject;
    const grossProfit = (100 * totalAmountLocal) / maxLocalTotal;

    LayoutService.setValue(
      grossProfitElem,
      grossProfit,
      this.layoutService,
      args.recordModel,
      0,
      args.sectionTagName,
      args.moduleStructure
    );

    console.log('grossProfit ', grossProfit);
  }

  PotentialAmount(args: FieldValueChangedArgs) {
    const section = args.recordModel.Categories.find(
      (x) => x.Id === args.sectionTagName
    );

    const sectionHeader = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunities'
    );
    const sectionLines = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunitiesLines'
    );

    const maxLocalTotalElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'MaxLocalTotal'
    );
    const grossProfitElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'GrossProfit'
    );
    const totalAmountLocalElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'TotalAmountLocal'
    );
    const WeightedSumLCElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'WeightedSumLC'
    );
    const PercentageRateElem = sectionLines.Lines[
      sectionLines.Lines.length - 1
    ].Properties.find((prop) => prop.Name === 'PercentageRate');
    const MaxLocalTotalLineElem = sectionLines.Lines[
      sectionLines.Lines.length - 1
    ].Properties.find((prop) => prop.Name === 'MaxLocalTotal');
    const WeightedAmountLocalElem = sectionLines.Lines[
      sectionLines.Lines.length - 1
    ].Properties.find((prop) => prop.Name === 'WeightedAmountLocal');

    const maxLocalTotal = maxLocalTotalElem.ValueAsObject;
    const grossProfit = grossProfitElem.ValueAsObject;
    const percentageRate = PercentageRateElem.ValueAsObject;

    const totalAmountLocal = (maxLocalTotal * grossProfit) / 100;
    const weightedSumLC = (maxLocalTotal * percentageRate) / 100;

    LayoutService.setValue(
      totalAmountLocalElem,
      totalAmountLocal,
      this.layoutService,
      args.recordModel,
      0,
      args.sectionTagName,
      args.moduleStructure
    );
    LayoutService.setValue(
      WeightedSumLCElem,
      weightedSumLC,
      this.layoutService,
      args.recordModel,
      0,
      args.sectionTagName,
      args.moduleStructure
    );
    LayoutService.setValue(
      WeightedAmountLocalElem,
      weightedSumLC,
      this.layoutService,
      args.recordModel,
      args.line,
      args.sectionTagName,
      args.moduleStructure
    );
    LayoutService.setValue(
      MaxLocalTotalLineElem,
      maxLocalTotal,
      this.layoutService,
      args.recordModel,
      0,
      args.sectionTagName,
      args.moduleStructure
    );

    console.log(
      'totalAmountLocal - weightedSumLC - maxLocalTotal ',
      totalAmountLocal,
      weightedSumLC,
      maxLocalTotal
    );
  }

  WeightedAmount(args: FieldValueChangedArgs) {
    const section = args.recordModel.Categories.find(
      (x) => x.Id === args.sectionTagName
    );

    const sectionHeader = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunities'
    );

    const sectionLines = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunitiesLines'
    );

    const maxLocalTotalElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'MaxLocalTotal'
    );
    const PercentageRateElem = sectionLines.Lines[
      sectionLines.Lines.length - 1
    ].Properties.find((prop) => prop.Name === 'PercentageRate');
    const WeightedSumLCElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'WeightedSumLC'
    );

    const percentageRate = PercentageRateElem.ValueAsObject;
    const weightedSumLC = WeightedSumLCElem.ValueAsObject;

    const maxLocalTotal = (100 * weightedSumLC) / percentageRate;

    LayoutService.setValue(
      maxLocalTotalElem,
      maxLocalTotal,
      this.layoutService,
      args.recordModel,
      0,
      args.sectionTagName,
      args.moduleStructure
    );
    this.PotentialAmount(args);
    console.log('maxLocalTotal ', maxLocalTotal);
  }

  // call in add
  ClosingPercentChanged(args: FieldValueChangedArgs) {
    const section = args.recordModel.Categories.find(
      (x) => x.Id === args.sectionTagName
    );

    const sectionHeader = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunities'
    );
    const sectionLines = args.recordModel.Categories.find(
      (x) => x.Id === 'SalesOpportunitiesLines'
    );

    let field = section.Lines.find((l) => l.Id === args.line).Properties.find(
      (prop) => prop.Name === args.recordProperty.Name
    );

    if (field != null || field !== undefined) {
      field = args.recordProperty;
    }

    const headerPercentElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'ClosingPersent'
    );
    const headerWeightedAmountElem = sectionHeader.Lines[0].Properties.find(
      (prop) => prop.Name === 'WeightedSumLC'
    );
    const weightedAmountElem = sectionLines.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'WeightedAmountLocal');
    const maxLocalTotalElem = sectionLines.Lines.find(
      (l) => l.Id === args.line
    ).Properties.find((prop) => prop.Name === 'MaxLocalTotal');

    const maxLocalTotal = maxLocalTotalElem.ValueAsObject;
    const percent = field.ValueAsObject;

    const weightedAmount = (maxLocalTotal * percent) / 100;

    const value = sectionLines.Lines[
      sectionLines.Lines.length - 1
    ].Properties.find((prop) => prop.Name === 'PercentageRate').ValueAsObject;

    LayoutService.setValue(
      headerPercentElem,
      value,
      this.layoutService,
      args.recordModel,
      0,
      args.sectionTagName,
      args.moduleStructure
    );
    LayoutService.setValue(
      weightedAmountElem,
      weightedAmount,
      this.layoutService,
      args.recordModel,
      0,
      args.sectionTagName,
      args.moduleStructure
    );
    LayoutService.setValue(
      headerWeightedAmountElem,
      weightedAmount,
      this.layoutService,
      args.recordModel,
      args.line,
      args.sectionTagName,
      args.moduleStructure
    );

    console.log(
      'headerPercentElem - weightedAmountElem - headerWeightedAmountElem ',
      value,
      weightedAmount,
      weightedAmount
    );
  }

  isNumber(val): boolean {
    return typeof val === 'number';
  }
}
